import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
	callAddRequestNotification, callGetRequestNotification, callDeleteRequestNotification, callRequestNotificationById,
	callGetNotificationErrorById
} from "../api/notifications/service";

const notificationSlice = createSlice({
	name: 'notificationData',
	initialState: {
		data: null,
		isLoading: true,
		error: null,
	},
	reducers: {
		setData: (state, { payload }) => {
			state.data = payload;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(callAddRequestNotification.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callAddRequestNotification.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callAddRequestNotification.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callGetRequestNotification.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callGetRequestNotification.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callGetRequestNotification.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callDeleteRequestNotification.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callDeleteRequestNotification.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callDeleteRequestNotification.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callRequestNotificationById.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callRequestNotificationById.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callRequestNotificationById.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
			.addCase(callGetNotificationErrorById.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callGetNotificationErrorById.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode !== "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left",
					});
				}
			})
			.addCase(callGetNotificationErrorById.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, { position: "top-left" });
			})
	},
});
export const { setData } = notificationSlice.actions;
export default notificationSlice.reducer;
